import React from 'react';

export const useRect = (ref: React.RefObject<any>): DOMRect | undefined => {
  const [rect, setRect] = React.useState<DOMRect>();

  const handleResize = React.useCallback(() => {
    if (ref.current) {
      const newRect: DOMRect = ref.current.getBoundingClientRect();
      if (JSON.stringify(newRect) !== JSON.stringify(rect)) {
        setRect(ref.current.getBoundingClientRect());
      }
    }
  }, [ref, rect]);

  React.useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }

    const resizeObserver: ResizeObserver = new ResizeObserver(() => handleResize());
    resizeObserver?.observe(ref.current);

    return () => {
      resizeObserver?.disconnect();
    };
  }, [ref, handleResize]);

  return rect;
};

export default useRect;
